const PATH_BASE = 'https://same-origin.invalid';
const CONTROL_CHARS = /[\u0000-\u001f\u007f]/;

export const sameOriginPath = (value?: string | null): string | null => {
  if (!value || !value.startsWith('/') || CONTROL_CHARS.test(value)) {
    return null;
  }

  if (value.startsWith('//') || value.startsWith('/\\')) {
    return null;
  }

  try {
    if (new URL(value, PATH_BASE).origin !== PATH_BASE) {
      return null;
    }
  } catch {
    return null;
  }

  return value;
};
